export default Object.freeze({
  subscriptionLimit: 'subscriptionLimit',
  offer: 'offer',
  preRequestModal: 'preRequestModal',
  requestHelpModal: 'requestHelpModal',
  updateEnquiryStatus: 'updateEnquiryStatus',
  prepareResponsesReport: 'prepareResponsesReport',
});
